// extracted by mini-css-extract-plugin
export default {"shop":"ShopPage_shop__3Lsyd","shop-name":"ShopPage_shop-name__d2dBC","content":"ShopPage_content__4iRI1"};